
import { mapGetters, mapMutations } from 'vuex';
import { formatPrice } from '@/modules/Helpers';

export default {
    props: {
        dish: { type: Object, required: true },
    },
    data() {
        return {
            showDescription: false,
        };
    },
    methods: {
        ...mapMutations('modal', ['setModal']),
        capitalize(string) {
            return string[0].toUpperCase() + string.slice(1);
        },
        openDishModal() {
            this.setModal({ type: 'Dish', data: { dish: this.dish } });
        },
    },
    computed: {
        ...mapGetters('order', [
            'items',
            'restaurantLocation',
            'isDelivery',
            'itemsCount',
            'groupCartUUID',
            'groupCartSlave',
        ]),
        ...mapGetters(['vat']),
        showFastelavnsBanner() {
            const restaurantName = this.restaurantLocation?.restaurant?.name?.toLowerCase() || '';
            const dishName = this.dish?.name?.toLowerCase() || '';
            const isFastelavnsBolle = dishName.includes('fastelavnsbolle') || dishName.includes('semlor');

            if (restaurantName.includes('vinthers') && dishName.includes('kagemand')) {
                return 'Kagemænd kan først leveres efter kl 9:00';
            }

            if (
                (restaurantName.includes('vinthers') && dishName.includes('kylling')) ||
                (restaurantName.includes('vinthers') && dishName.includes('roastbeef')) ||
                (restaurantName.includes('vinthers') && dishName.includes('tun salat')) ||
                (restaurantName.includes('vinthers') && dishName.includes('skinke')) ||
                (restaurantName.includes('vinthers') && dishName.includes('frikadelle'))
            ) {
                return 'Sandwiches kan først leveres efter kl 9:00';
            }

            if (!isFastelavnsBolle) return false;

            if (restaurantName.includes('farumhus') || restaurantName.includes('andersen')) {
                return 'Fastelavnsboller kan først leveres efter kl 9:30';
            }
            if (restaurantName.includes('r-bakery')) {
                return 'Fastelavnsboller kan først leveres efter kl 10:30';
            }
            return false;
        },
        quantity() {
            // if (this.dish.food_option_groups.length) {
            //     return false;
            // }
            return this.cartItems.reduce((sum, x) => sum + x.quantity, 0);
        },
        cartItems() {
            if (this.groupCartUUID && !this.groupCartSlave) {
                return this.items.filter(item => item.id === this.dish.id && !item.added_by_name);
            } else {
                return this.items.filter(item => item.id === this.dish.id);
            }
        },
        price() {
            if (this.dish.price === 0) {
                return 'GRATIS';
            }
            if (this.vat === 'excl') {
                return formatPrice(this.dish.price * 0.8);
            } else {
                return formatPrice(this.dish.price);
            }
        },
        name() {
            return this.dish.name;
        },
        picture() {
            return this.dish.picture;
        },
        description() {
            return this.dish.description;
        },
        variantText() {
            return this.dish.variant_text;
        },
        swiperSettings() {
            return {
                // initialSlide: 0,
                // slidesPerView: 1,
                slideToClickedSlide: true,
                // speed: 1000,
                cssMode: false,
                // loop: true,
                // spaceBetween: 20,
                /* autoplay: {
                    delay: 8000
                }, */
                navigation: {
                    prevEl: '.swiper-navigation-prev',
                    nextEl: '.swiper-navigation-next',
                    enabled: true,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },

                /*
                    initialSlide: this.currentCategoryIndex || 0,
                    slidesPerView: 'auto',
                    slideToClickedSlide: true,
                    cssMode: true,
                */
            };
        },
    },
};
